module.exports = {
  defaultLocale: 'en',
  prerender: true,
};



// WEBPACK FOOTER //
// ./src/config/app.conf.js